<template>
  <div class="help">
    <h1>Need Help?</h1>
    <p>If you have any questions or concerns, feel free to reach out to us!</p>
    <a href="mailto:contact@cognifynote.com?subject=Help%20with%20the%20application&body=Hello%20support%20team,%0A%0AI%20need%20help%20with...">
      Contact Support via Email
    </a>
  </div>
</template>

<script>
export default {
  name: "HelpPage",
};
</script>

<style scoped>
.help {
  text-align: center;
  padding: 20px;
}

a {
  color: #007bff;
  text-decoration: none;
  font-size: 18px;
  margin-top: 20px;
  display: inline-block;
}

a:hover {
  text-decoration: underline;
}
</style>